import { render } from "./basic-information.vue?vue&type=template&id=f1caa09a&scoped=true&ts=true"
import script from "./basic-information.vue?vue&type=script&lang=ts"
export * from "./basic-information.vue?vue&type=script&lang=ts"

import "./basic-information.vue?vue&type=style&index=0&id=f1caa09a&scoped=true&lang=css"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1caa09a"]])

export default __exports__